export default {
  header: 'Oops, a apărut ceva neașteptat',
  text: 'Reporniți pagina sau faceți clic pe butonul „Înapoi la meniu" de mai jos.',
  button: 'Înapoi la Start',
};
